import { useChoiceGroupContext } from '../../../ChoiceGroupContext';

interface Payload<T> {
    value: T;
    disabled: boolean;
    onClickProp: (newValue: T) => void;
}

function useChoiceGroupItem<T>({ value, disabled, onClickProp }: Payload<T>) {
    const { value: groupValue, multiple, onItemClick, size = 'md', fill } = useChoiceGroupContext<T>();

    const isSelected = Array.isArray(groupValue) && multiple ? groupValue.includes(value) : groupValue === value;

    const onClick = (newValue: T) => {
        if (disabled) {
            return;
        }

        onItemClick(newValue);
        onClickProp(newValue);
    };

    return {
        isSelected,
        onClick,
        multiple,
        size,
        fill,
    };
}

export default useChoiceGroupItem;
